class AccordionAnimations {
  constructor() {
    this.init();
  }

  init() {
    // Find all accordion details elements
    const accordions = document.querySelectorAll(".accordion details");

    accordions.forEach((accordion) => {
      const summary = accordion.querySelector("summary");
      const content = accordion.querySelector(".accordion__content");

      if (!summary || !content) return;

      // Set initial state
      if (!accordion.hasAttribute("open")) {
        content.style.maxHeight = "0px";
        content.style.opacity = "0";
        content.style.paddingTop = "0";
        content.style.paddingBottom = "0";
        content.style.marginBottom = "0";
      }

      // Add click event listener
      summary.addEventListener("click", (e) => {
        e.preventDefault();
        this.toggleAccordion(accordion, content);
      });
    });
  }

  toggleAccordion(accordion, content) {
    const isOpen = accordion.hasAttribute("open");

    if (isOpen) {
      this.closeAccordion(accordion, content);
    } else {
      this.openAccordion(accordion, content);
    }
  }

  openAccordion(accordion, content) {
    // Set the details element to open
    accordion.setAttribute("open", "");

    // Get the natural height of the content
    const contentHeight = content.scrollHeight;

    // Set initial styles for animation
    content.style.maxHeight = "0px";
    content.style.opacity = "0";
    content.style.paddingTop = "0";
    content.style.paddingBottom = "0";
    content.style.marginBottom = "0";

    // Force a reflow
    content.offsetHeight;

    // Animate to open state
    requestAnimationFrame(() => {
      content.style.transition =
        "max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease, margin 0.3s ease";
      content.style.maxHeight = contentHeight + "px";
      content.style.opacity = "1";
      content.style.paddingTop = "0.6rem";
      content.style.paddingBottom = "0.6rem";
      content.style.marginBottom = "1.5rem";

      // Clean up after animation
      setTimeout(() => {
        content.style.maxHeight = "none";
        content.style.transition = "";
      }, 300);
    });
  }

  closeAccordion(accordion, content) {
    // Get current height
    const contentHeight = content.scrollHeight;

    // Set styles for closing animation
    content.style.maxHeight = contentHeight + "px";
    content.style.transition =
      "max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease, margin 0.3s ease";

    // Force a reflow
    content.offsetHeight;

    // Animate to closed state
    requestAnimationFrame(() => {
      content.style.maxHeight = "0px";
      content.style.opacity = "0";
      content.style.paddingTop = "0";
      content.style.paddingBottom = "0";
      content.style.marginBottom = "0";

      // Remove open attribute after animation
      setTimeout(() => {
        accordion.removeAttribute("open");
        content.style.transition = "";
      }, 300);
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
  new AccordionAnimations();
});

// Re-initialize for dynamically loaded content
document.addEventListener("shopify:section:load", () => {
  new AccordionAnimations();
});
